import React from 'react';

const MISSING_PRICING_TEXT = 'No customer rental pricing exists for this billing period.';

export const missingRentalPricingColumn = {
  Header: 'Customer Pricing',
  id: 'missingRentalPricing',
  accessor: ({ missingRentalPricing }) => (missingRentalPricing ? 'No Pricing' : ''),
  disableSortBy: true,
  excludeGlobalFilter: true,
  Cell: ({ value }) =>
    value ? (
      <span className="text-danger fw-bold" title={MISSING_PRICING_TEXT}>
        <i className="bi bi-exclamation-triangle-fill me-1" />
        {value}
      </span>
    ) : null,
};

export const LiquidRentalMissingPricingBanner: React.FC<any> = ({ entity }) => {
  if (!entity?.missingRentalPricing) return null;
  return (
    <div className="alert alert-warning fw-bold mb-2 py-2">
      <i className="bi bi-exclamation-triangle-fill me-2" />
      {MISSING_PRICING_TEXT} This invoice may be $0.00 because the customer has no pricing.
    </div>
  );
};
